/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react'
import { KTSVG } from '../../helpers'
import { LanguageHelp, getConfig } from '../../helpers/LanguageHelper'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import clsx from 'clsx'
import { freezeAccount } from '../../../app/modules/auth/core/_requests';

export class FreezeAccountDto { Password = ''; ConfirmPassword = ''; }

const FreezeAccountModal: FC = ({ }) => {
  const lang = getConfig()
  const [isPasswordShow, setIsPasswordShow] = useState(false)

  const freezeAccountSchema = Yup.object().shape({
    Password: Yup.string()
      .min(8, LanguageHelp('Must contain 8 characters!'))
      .max(25, LanguageHelp('Must contain no more than 25 characters!'))
      .matches(/^(?=.*[\!\@\#\$\%\^\'\&\*\_\+\=\|\;\:\,\.\~\-])/, LanguageHelp("One special character required! -> !@#$%^'&*-_+=|;:,.~"))
      .matches(/^(?=.*[0-9])/, LanguageHelp("One special character required!"))
      .matches(/^(?=.*[a-z])/, LanguageHelp("One lowercase required!"))
      .matches(/^(?=.*[A-Z])/, LanguageHelp("One uppercase required!"))
      .required(LanguageHelp('Password is required')),
    ConfirmPassword: Yup.string()
      .required(LanguageHelp('Password confirmation is required'))
      .when('Password', {
        is: (val: string) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf([Yup.ref('Password')], LanguageHelp("The passwords you entered do not match.")),
      }),
  })

  const [objectFreezeAccountDto] = useState(new FreezeAccountDto())

  const formik = useFormik({
    initialValues: objectFreezeAccountDto,
    validationSchema: freezeAccountSchema,
    onSubmit: async (values, { setSubmitting }) => {
      let isSuccess = false
      try {
        var freezeAccountResult = await freezeAccount(values.Password, values.ConfirmPassword)
        if (freezeAccountResult.data.httpStatusCode === 200) {
          isSuccess = true
          toast.success(LanguageHelp('Account has been successfully deleted!'));
        }
        else
          toast.error(LanguageHelp(freezeAccountResult.data.message))
      } catch (ex) {
        if (ex instanceof Error) {
          toast.error(LanguageHelp(ex.message));
        } else {
          console.log("Unexpected error", ex);
        }
      } finally {
        setSubmitting(false)
        if (isSuccess === true)
          window.location.reload()
      }
    },
  })

  return (
    <div className='modal fade' id='kt_modal_freezeAccount' aria-hidden='true'>
      <div className='modal-dialog modal-l'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>{LanguageHelp('Freeze Account')}</h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
          </div>
          <div className='modal-header justify-content-end border-0 pb-0'>
            <form className='form' style={{ minWidth: "-webkit-fill-available" }} onSubmit={formik.handleSubmit} noValidate>
              {/* begin::Scroll */}
              <div
                id='kt_modal_add_user_scroll'
                data-kt-scroll='true'
              >
                <div className='card-body border-top'>
                  <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-2tx svg-icon-warning me-4'
                    />

                    <div className='d-flex flex-stack flex-grow-1'>
                      <div className='fw-bold'>
                        <h4 className='text-gray-800 fw-bolder'>{LanguageHelp('You Are Deactivating Your Account')}</h4>
                        <div className='fs-6 text-gray-600'>
                          {LanguageHelp('If you want, try writing to us here before you decide.')}
                          <a href='https://www.aisenseus.net/contact/' target='_blank' className='text-gray-800 text-hover-primary' >
                            &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* begin::Form group Password */}
                <div className='fv-row mb-8'>
                  <div className='mb-1'>
                    <label className='form-label fw-bolder text-dark fs-6'>{LanguageHelp("Password")}</label>
                    <div className='position-relative mb-3'>
                      <div className="input-group mb-5">
                        <input
                          type={isPasswordShow ? 'text' : 'password'}
                          placeholder={LanguageHelp("Password")}
                          autoComplete='off'
                          {...formik.getFieldProps('Password')}
                          className={clsx(
                            'form-control bg-transparent',
                            {
                              'is-invalid': formik.touched.Password && formik.errors.Password,
                            },
                            {
                              'is-valid': formik.touched.Password && !formik.errors.Password,
                            }
                          )}
                        />
                        <span className="input-group-text" onClick={(e) => { setIsPasswordShow(!isPasswordShow); }}>
                          {isPasswordShow && <i style={{ cursor: "pointer", minWidth: "30px" }} className='far fa-eye-slash fs-2 text-primary'></i>}
                          {!isPasswordShow && <i style={{ cursor: "pointer", minWidth: "30px" }} className='far fa-eye fs-2 text-primary'></i>}
                        </span>
                      </div>

                      {formik.touched.Password && formik.errors.Password && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.Password}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {formik.touched.Password && formik.errors.Password && (
                    <div className='form-text'>
                      {LanguageHelp('Your password should be 8-25 characters long and should contain at least one lowercase, one uppercase, one numeric digit and one special characters! !@#$%^\'&*-_+=|;:,.~')}
                    </div>
                  )}
                </div>
                {/* end::Form group */}

                {/* begin::Form group Confirm password */}
                <div className='fv-row mb-5'>
                  <label className='form-label fw-bolder text-dark fs-6'>{LanguageHelp("Confirm Password")}</label>
                  <div className="input-group mb-5">
                    <input
                      type={isPasswordShow ? 'text' : 'password'}
                      placeholder={LanguageHelp("Confirm Password")}
                      autoComplete='off'
                      {...formik.getFieldProps('ConfirmPassword')}
                      className={clsx(
                        'form-control bg-transparent',
                        {
                          'is-invalid': formik.touched.ConfirmPassword && formik.errors.ConfirmPassword,
                        },
                        {
                          'is-valid': formik.touched.ConfirmPassword && !formik.errors.ConfirmPassword,
                        }
                      )}
                    />
                    <span className="input-group-text" onClick={(e) => { setIsPasswordShow(!isPasswordShow); }}>
                      {isPasswordShow && <i style={{ cursor: "pointer", minWidth: "30px" }} className='far fa-eye-slash fs-2 text-primary'></i>}
                      {!isPasswordShow && <i style={{ cursor: "pointer", minWidth: "30px" }} className='far fa-eye fs-2 text-primary'></i>}
                    </span>
                  </div>
                  {formik.touched.ConfirmPassword && formik.errors.ConfirmPassword && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.ConfirmPassword}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              {/* end::Scroll */}

              {/* begin::Actions */}
              <div className='text-center pt-10 pb-5'>
                <button
                  type='submit'
                  className='btn btn-danger'
                  data-kt-users-modal-action='submit'
                  disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                >
                  <span className='indicator-label'>{LanguageHelp('Freeze Account')}</span>
                  {(formik.isSubmitting) && (
                    <span className='indicator-progress'>
                      {LanguageHelp('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Actions */}
            </form>
          </div>
        </div></div>
    </div>
  )
}

export { FreezeAccountModal }
